import React from 'react';
import IconUploadVideo from 'images/upload_video.png';
const UploadSection = ({ handleOnDrop, handleDragLeave, handleDragOver, changeMultipleFiles, showUpload }) => (
  <React.Fragment>
    <div className='d-flex text-center justify-content-center align-items-center'>
      <img className="create-akaire-box-icon-upload filter-black-icon"
        src={IconUploadVideo} alt="アップロード" width="50" />
      <span className='create-akaire-box-title-content ml-4 mt-1'>動画データをまとめてアップロードする</span>
    </div>
    <div className='d-flex text-center justify-content-center align-items-center'>
      <span className="text-black">※一度にアップロードできるのは最大30ページです。</span>
    </div>
  </React.Fragment>
);
export default UploadSection;
